/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export enum ProductInventoryStatus {
  inStock = "inStock",
  lowStock = "lowStock",
  outOfStock = "outOfStock",
}

export interface AddLineItemInput {
  quantity?: number | null;
  skuCode?: string | null;
  warrantySkuCode?: string | null;
}

//==============================================================
// END Enums and Input Objects
//==============================================================
